import React from 'react';

class NotfoundPage extends React.Component {
	//constructor(props){
	//	super(props);
	//}
	render (){
		return (
			<div id="notfound">
				not found
				<div className="btns">
					<button
						onClick={()=>this.do()}
					>TOP</button>
				</div>
			</div>
		)	
	}
	do(){
		this.props.setState({mode:"top"});
	}
}

export default NotfoundPage;